import { render, staticRenderFns } from "./OrganizationConnection.vue?vue&type=template&id=f2a11a36&"
import script from "./OrganizationConnection.vue?vue&type=script&lang=js&"
export * from "./OrganizationConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports